module.exports = __webpack_public_path__ + "img/30e4a2b6-4a89-4f25-b8c4-293b4af1badf-min.a8883b73.jpg";